module.exports = __webpack_public_path__ + "static/media/ig23.2cfd62f9.jpg";